import { useEffect } from 'react'
import { toastManager } from '@systemeio/components'
import { Trans, useTranslation } from 'next-i18next'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import useUser from 'shared/hooks/use-user'
import { buildDashboardUrl } from 'modules/white-label/utils/dashboard-url'

const RESTRICTED_ID = 'restricted-access-toast'

export const useRestrictedAccessNotification = (): void => {
  const { t } = useTranslation()
  const { isAccessRestricted } = useUser()

  useEffect(() => {
    if (isAccessRestricted) {
      toastManager.add({
        id: RESTRICTED_ID,
        type: 'error',
        timeout: 0,
        description: (
          <Trans
            t={t}
            i18nKey="global.account_restricted.notification"
            components={{
              a: (
                <LinkWithoutPrefetch
                  href={buildDashboardUrl('/profile/user-plan')}
                  className="primary-link hover:text-text-link-hover"
                />
              ),
            }}
          />
        ),
      })
    }
  }, [isAccessRestricted])
}
